<script>
export default {
  name: 'ErrorsViewer',
  template: '#errors-viewer-template',
  props: {
    errors: {
      type: Object,
      required: true,
    },
  },
};
</script>
